import httpApiApplication from '@/app/http/httpApiApplication';

import { type CurrentAccountTaxpayerStats } from '../models/CurrentAccounts';

export const currentAccountService = {
  getTaxpayerStats: async (): Promise<Array<CurrentAccountTaxpayerStats>> => {
    const response =
      await httpApiApplication.get<Array<CurrentAccountTaxpayerStats>>('/current-account/stats');

    return response;
  }
};
